import { useEffect, useRef } from "react";
import { useSocket } from "./SocketContext";

/**
 * Subscribe to one Socket.io event without re-subscribing when handler identity changes.
 * @param {string | null | undefined} event
 * @param {((...args: unknown[]) => void) | null | undefined} handler
 */
export function useSocketEvent(event, handler) {
  const socket = useSocket();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!socket || !event || !handler) return undefined;
    const fn = (...args) => {
      handlerRef.current?.(...args);
    };
    socket.on(event, fn);
    return () => {
      socket.off(event, fn);
    };
  }, [socket, event, handler]);
}
